import { useState } from "react";
import { useTranslation } from "react-i18next";
import TkPopElectrodeCreateDialog from "../dialogTypes/TkPopElectrodeCreateDialog";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";

function TkPopElectrodeCreateButton(props) {

    const { t } = useTranslation();

    const { id, schema, refresh, onSuccess, onSelectMst, createButtonName, customizeErrorMsgCallback, ...others } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {

        setOpen(true);

    };

    const onClose = () => {

        setOpen(false);

    };

    const onCreateSuccess = (msg) => {

        if (onSuccess) {

            onSuccess(msg);

        }

        refresh.refresh();

    };

    return (

        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={id + "Create"} {...others} />
            <TkPopElectrodeCreateDialog
                id={id + "create-dialog"}
                mode="create"
                formId={id + "create-form"}
                title={schema ? t(`dialog.title.${id}.create`) : ""}
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onClose}
                onSelectMst={onSelectMst}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>

    );
}

export default TkPopElectrodeCreateButton;

